import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  computed,
  inject,
} from '@angular/core';
import { ListingDetailService } from '../../services/listing-detail.service';
import { PlannerStore } from '../../services/planner-store';

@Component({
  selector: 'app-pin-detail-sheet',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './pin-detail-sheet.component.html',
  styleUrl: './pin-detail-sheet.component.css',
})
export class PinDetailSheetComponent {
  readonly detailService = inject(ListingDetailService);
  private readonly store = inject(PlannerStore);

  readonly isOpen = computed(() => this.detailService.openedId() !== null);

  readonly isInPlan = computed(() => {
    const id = this.detailService.openedId();
    return id != null && this.store.stops().includes(id);
  });

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.detailService.close();
  }

  close(): void {
    this.detailService.close();
  }

  retry(): void {
    this.detailService.retry();
  }

  addToPlan(): void {
    const id = this.detailService.openedId();
    if (id == null) return;
    this.store.addStop(id);
    this.detailService.close();
  }

  removeFromPlan(): void {
    const id = this.detailService.openedId();
    if (id == null) return;
    this.store.removeStop(id);
    this.detailService.close();
  }
}
